// extracted by mini-css-extract-plugin
export default {"root":"MyEpic_root__QvD7b","title":"MyEpic_title__4O1Bc","list":"MyEpic_list__DFXYy","loader":"MyEpic_loader__MlNI-","name":"MyEpic_name__wdWEo","fullCard":"MyEpic_fullCard__KvyJv"};